import { path } from 'ramda';

export default path;
